import { BaseStore } from "../../../../react-core/Flux/BaseStore";
import { InvestmentTransferDispatcher } from "./Variable";
import { ActionType } from "../../../../react-core/Flux/ActionType";
import { InvestmentDetails } from "../../../../Wrap/Models/Domains/Transfer/InvestmentDetails";

export interface ISubInvestment {
    detail: InvestmentDetails;
    isMoveAll: boolean;
    moveQuantity: number;
    amendBookCost: number;
    acquisitionDate: Date;
    CGT: boolean;
}
export interface IInvestmentTransfer {
    detail: InvestmentDetails;
    isMoveAll: boolean;
    moveQuantity: number;
    isToggle: boolean;
    amendBookCost: number;
    acquisitionDate: Date;
    CGT: boolean;
    subInvestment?: ISubInvestment[];
}

export interface InvestmentTransferStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: IInvestmentTransfer[];
}

export class InvestmentTransferStoreStatic extends BaseStore<InvestmentTransferStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(InvestmentTransferDispatcher, (actionData) =>
            this.onInvestmentTransferStoreResponse(actionData)
        );
    }

    public getLastResult(): InvestmentTransferStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getInvestments() {
        return this.getState().data || [];
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): InvestmentTransferStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onInvestmentTransferStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
